import _extends from "@babel/runtime/helpers/extends";
import { SwitchProductModule } from '@wix/package-picker-sdk';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { useCurrentModule } from '../ModuleProvider';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../../utils/moduleNames';
import { useAiRecommendationEnabled } from '../../hooks/useAiRecommendationEnabled';
import { useEffectiveRecommendation } from '../../hooks/useEffectiveRecommendation';
import { useSaleDiscountLabel } from '../../hooks/useSaleDiscountLabel';
import { AiRecommendedHat } from './AiRecommendedHat';
import { ProductHatUi } from './ProductHatUi';
export const useProductHat = _ref => {
  let {
    productId,
    excludeSaleVariant = false
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const isMobile = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME;
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    data: {
      isCurrentProduct
    } = {
      isCurrentProduct: false
    }
  } = SwitchProductModule.SDK.switchApiClient.hooks.useIsCurrentProduct({
    productId
  });
  const {
    label: saleLabel
  } = useSaleDiscountLabel({
    productId
  });
  const {
    recommendedDisplayText,
    isRecommended: catalogIsRecommended,
    hasSale
  } = product ?? {};
  const {
    isEnabled: isAiRecommendationEnabled
  } = useAiRecommendationEnabled();
  const {
    isRecommended,
    isAiRecommended
  } = useEffectiveRecommendation(productId, catalogIsRecommended ?? false);
  const hasSaleHat = Boolean(hasSale) && !excludeSaleVariant;
  const isProductHat = isRecommended || hasSaleHat || isCurrentProduct || !isAiRecommendationEnabled && Boolean(catalogIsRecommended);
  const isAiHat = isProductHat && isMobile && isAiRecommended;
  const renderProductHat = function (props) {
    if (props === void 0) {
      props = {};
    }
    if (isCurrentProduct) {
      return /*#__PURE__*/React.createElement(ProductHatUi, _extends({
        variant: "currentProduct",
        text: t('premium-purchase-plan.cards.hat.current_plan')
      }, props));
    }
    if (hasSale && !excludeSaleVariant) {
      return /*#__PURE__*/React.createElement(ProductHatUi, _extends({
        variant: "sale",
        text: saleLabel
      }, props));
    }
    if (isRecommended) {
      if (isAiHat) {
        return /*#__PURE__*/React.createElement(AiRecommendedHat, {
          productId: productId
        });
      }
      return /*#__PURE__*/React.createElement(ProductHatUi, _extends({
        variant: "recommended",
        text: isAiRecommended ? t('premium-purchase-plan.cards.hat.recommended') : recommendedDisplayText ?? '',
        isRevealing: isAiRecommended
      }, props));
    }
    return /*#__PURE__*/React.createElement(ProductCardList.Default.Card.Tag, _extends({
      height: props.height ?? '30px',
      isVisible: true
    }, props));
  };
  return {
    renderProductHat,
    isProductHat,
    isAiHat
  };
};
//# sourceMappingURL=useProductHat.js.map